import React, {useEffect, useMemo, useState} from 'react';
import Translate from "../../../../../components/Translate";
import Active from "../../../../../assets/images/ongoing.png";
import Forward from "../../../../../assets/images/forward-statistics.png";
import Unanswered from "../../../../../assets/images/missed-call.png";
import Answered from "../../../../../assets/images/call.png";
import Clock from "../../../../../assets/images/clock.png";
import Limit from "../../../../../assets/images/limit.png";
import {calculateRank, formatSecondsToHHMMSS, myDarkBlue} from "../../../../../utils/General";
import Input from "../../../../../components-new/Input";
import config from "../../../../../config";
import RatingStars from "../../../../../components/rating-stars/RatingStars";
import Info from "../../../../../assets/images/info.png";
import Tooltip from "../../../../../components-new/Tooltip";
import {getOperatorsTimes, getStatisticNumbers} from "../../../../../services/statistics/api";
import Chat from "../../../../../assets/images/chats.png";
import LoadingComponent from "../../../../../assets/LoadingComponent";
import {confirmActionRequested} from "../../../../../services/confirmAction/action";
import {connect} from "react-redux";

const OperatorStatistics = ({
                                company,
                                user,
                                currentStatusStartDate,
                                currentStatusEndDate,
                                setCurrentStatusStartDate,
                                setCurrentStatusEndDate,
                                dailyChatsLimit,
                                currentChatsLimit,
                                currentStatusHistory,
                                openTrModal
                            }) => {

    const subs = company.subs ? company.subs : [];

    const rating = parseInt((user.goodAnswer * 100) / (user.goodAnswer + user.badAnswer));
    const ratingInStars = (rating * 5) / 100

    const ratingTotal = user.goodAnswer + user.badAnswer;
    const _rating = ratingTotal ? parseInt((user.goodAnswer * 100) / ratingTotal) : 0;

    const ratingPercent = _rating;

    const [isFetchingNumbers, setIsFetchingNumbers] = useState(false);
    const [statNumbers, setStatNumbers] = useState({
        allRequests: 0,
        todaysRequests: 0,
        answeredRequests: 0,
        unansweredRequests: 0,
        activeRequests: 0,
        forwardedRequests: 0
    });

    const [isFetchingTimes, setIsFetchingTimes] = useState(false);
    const [operatorTimes, setOperatorTimes] = useState({
        avgResponseTime: null,
        avgFirstAnswerTime: null,
        avgConversationTime: null
    })
    const [operatorTimesStart, setOperatorTimesStart] = useState('');
    const [operatorTimesEnd, setOperatorTimesEnd] = useState('');

    useEffect(() => {
        fetchNumbers()

        const interval = setInterval(fetchNumbers, 30000)

        return () => clearInterval(interval)
    }, [])

    useEffect(fetchTimes, [operatorTimesStart, operatorTimesEnd])

    const rank = useMemo(() => {
        return calculateRank({
            ratingPercent,
            avrgAnswerSpeed: operatorTimes.avgResponseTime,
            answeredChatsCount: statNumbers.answeredRequests,
        })
    }, [ratingPercent, operatorTimes.avgResponseTime, statNumbers.answeredRequests])


    function fetchNumbers() {
        if (isFetchingNumbers) return;

        setIsFetchingNumbers(true);
        getStatisticNumbers(subs.map(sub => sub.id), user.postgresId).then(result => {
            if (result) {
                setStatNumbers(result);
            }
        }).finally(() => {
            setIsFetchingNumbers(false);
        })
    }

    function fetchTimes() {
        if (isFetchingTimes) return;
        setIsFetchingTimes(true);

        getOperatorsTimes(subs.map(sub => sub.id), [user.postgresId], operatorTimesStart, operatorTimesEnd).then(result => {
            if (result && result[0]) {
                setOperatorTimes({
                    avgResponseTime: parseInt(result[0].avgResponseTime),
                    avgFirstAnswerTime: parseInt(result[0].avgFirstAnswerTime),
                    avgConversationTime: parseInt(result[0].avgConversationTime)
                });
            }else {
                setOperatorTimes({
                    avgResponseTime: null,
                    avgFirstAnswerTime: null,
                    avgConversationTime: null
                })
            }
        }).finally(() => {
            setIsFetchingTimes(false);
        })
    }


    return (
        <React.Fragment>
            <div onClick={() => openTrModal('allRequestsToOperator')}
                 className="statistic-card statistic-card-hoverable">
                <h2><Translate text={'allRequestsToOperator'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Chat}/>
                {isFetchingNumbers ? <LoadingComponent/>
                    :
                    <span className="count">{statNumbers.allRequests}</span>
                }
            </div>
            <div onClick={() => openTrModal('todaysRequestsToOperator')}
                 className="statistic-card statistic-card-hoverable">
                <h2><Translate text={'todaysRequestsToOperator'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Chat}/>
                {isFetchingNumbers ? <LoadingComponent/>
                    :
                    <span className="count">{statNumbers.todaysRequests}</span>
                }
            </div>
            <div onClick={() => openTrModal('answeredRequestsToOperator', {unanswered: false})}
                 className="statistic-card statistic-card-hoverable">
                <h2><Translate text={'answeredRequestsToOperator'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Answered}/>
                {isFetchingNumbers ? <LoadingComponent/>
                    :
                    <span className="count">{statNumbers.answeredRequests}</span>
                }
            </div>
            <div onClick={() => openTrModal('unansweredRequestsToOperator', {unanswered: true})}
                 className="statistic-card statistic-card-hoverable">
                <h2><Translate text={'unansweredRequestsToOperator'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Unanswered}/>
                {isFetchingNumbers ? <LoadingComponent/>
                    :
                    <span className="count">{statNumbers.unansweredRequests}</span>
                }
            </div>
            <div onClick={() => openTrModal('activeRequests', {statuses: 'OPERATOR_PROCESSING'})}
                 className="statistic-card statistic-card-hoverable">
                <h2><Translate text={'activeRequests'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Active}/>
                {isFetchingNumbers ? <LoadingComponent/>
                    :
                    <span className="count">{statNumbers.activeRequests}</span>
                }
            </div>

            <div onClick={() => openTrModal('forwardedRequestsToOperator', {forwarded: true})}
                 className="statistic-card statistic-card-hoverable">
                <h2><Translate text={'forwardedRequestsToOperator'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Forward}/>
                {isFetchingNumbers ? <LoadingComponent/>
                    :
                    <span className="count">{statNumbers.forwardedRequests}</span>
                }
            </div>

            <div className="statistic-card">
                <h2>
                    <Translate text={'Rating'}/>
                </h2>
                <RatingStars value={ratingInStars}/>
                <br/>
                <span className="count" style={{display: 'flex', gap: '5px'}}>
                    <Tooltip text={'Rating'}>{_rating}</Tooltip> / <Tooltip
                    text={'ratingCount'}>{user.goodAnswer + user.badAnswer}</Tooltip>
                </span>
                <br/>

                <strong style={{
                    color: myDarkBlue,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px'
                }}>
                    <Translate text={'Level'}/> {rank}
                    <Tooltip text="rankDescription">
                        <span style={{display: 'flex'}}>
                            <img width={17} height={17} src={Info}/>
                        </span>
                    </Tooltip>
                </strong>
            </div>

            <div className="statistic-card">
                <h2><Translate text={'dailyChatsLimit'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Limit}/>
                <span className="count">{dailyChatsLimit !== '' ? (dailyChatsLimit >= 999 ?
                    <span style={{fontSize: '13px'}}><Translate
                        text={'unlimited'}/></span> : dailyChatsLimit) : '...'}</span>
            </div>

            <div className="statistic-card">
                <h2><Translate text={'currentChatLimit'}/></h2>
                <img style={{marginBottom: '10px'}} width={40} height={40} src={Limit}/>
                <span className="count">{currentChatsLimit !== '' ? (currentChatsLimit >= 999 ?
                    <span style={{fontSize: '13px'}}><Translate
                        text={'unlimited'}/></span> : currentChatsLimit) : '...'}</span>
            </div>

            <div className="statistic-card" style={{flexBasis: '100%'}}>
                <h2><Translate text={'operatorsTimeStatistics'}/></h2>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '10px',
                        marginBottom: '20px',
                        flexWrap: 'wrap',
                    }}
                >
                    <Input
                        style={{width: '240px', height: '40px'}}
                        className={'calendar-select'}
                        type="date"
                        disabled={isFetchingTimes}
                        value={operatorTimesStart}
                        onChange={(e) => setOperatorTimesStart(e.target.value)}
                    />

                    <Input
                        style={{width: '240px', height: '40px'}}
                        className={'calendar-select'}
                        type="date"
                        disabled={isFetchingTimes}
                        value={operatorTimesEnd}
                        onChange={(e) => setOperatorTimesEnd(e.target.value)}
                    />
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '20px',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}
                >
                    <div className="statistic-card" style={{padding:'24px',minHeight:'150px'}}>
                        <img style={{marginBottom: '14px'}} width={48} height={48} src={Clock} alt="status icon"/>
                        <h2
                            style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#333',
                                marginBottom: '6px',
                                textTransform: 'capitalize',
                            }}
                        >
                            <Translate text={'avrgAnswerSpeed'}/>
                        </h2>
                        {isFetchingTimes ? (
                            <LoadingComponent/>
                        ) : (
                        <span style={{fontSize: '20px', fontWeight: 700, color: myDarkBlue}}>
                            {operatorTimes.avgResponseTime
                                ? formatSecondsToHHMMSS(operatorTimes.avgResponseTime)
                                : 'N/A'}
                        </span>
                        )}
                    </div>

                    <div className="statistic-card" style={{padding:'24px',minHeight:'150px'}}>
                        <img style={{marginBottom: '14px'}} width={48} height={48} src={Clock} alt="status icon" />
                        <h2
                            style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#333',
                                marginBottom: '6px',
                                textTransform: 'capitalize',
                            }}
                        >
                            <Translate text={'avrgFirstAnswerSpeed'}/>
                        </h2>
                        {isFetchingTimes ? (
                            <LoadingComponent/>
                        ) : (
                            <span style={{fontSize: '20px', fontWeight: 700, color: myDarkBlue}}>
            {operatorTimes.avgFirstAnswerTime
                ? formatSecondsToHHMMSS(operatorTimes.avgFirstAnswerTime)
                : 'N/A'}
        </span>
                        )}
                    </div>

                    <div className="statistic-card" style={{padding:'24px',minHeight:'150px'}}>
                        <img style={{marginBottom: '14px'}} width={48} height={48} src={Clock} alt="status icon" />
                        <h2
                            style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#333',
                                marginBottom: '6px',
                                textTransform: 'capitalize',
                            }}
                        >
                            <Translate text={'avrgConvTime'}/>
                        </h2>
                        {isFetchingTimes ? (
                            <LoadingComponent/>
                        ) : (
                            <span style={{fontSize: '20px', fontWeight: 700, color: myDarkBlue}}>
            {operatorTimes.avgConversationTime
                ? formatSecondsToHHMMSS(operatorTimes.avgConversationTime)
                : 'N/A'}
        </span>
                        )}
                    </div>
                </div>
            </div>

            <React.Fragment>
                <div className="statistic-card">
                    <h2><Translate text={'currentStatusHistory'}/></h2>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            marginBottom: '20px',
                            flexWrap: 'wrap',
                        }}
                    >
                        <Input
                            style={{width: '240px', height: '40px'}}
                            className={'calendar-select'}
                            type="date"
                            value={currentStatusStartDate}
                            onChange={(e) => setCurrentStatusStartDate(e.target.value)}
                        />

                        <Input
                            style={{width: '240px', height: '40px'}}
                            className={'calendar-select'}
                            type="date"
                            value={currentStatusEndDate}
                            onChange={(e) => setCurrentStatusEndDate(e.target.value)}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            justifyContent: 'space-between',
                            width: '100%'
                        }}
                    >
                        {Object.entries(config.currentStatusMap).map(([key, status]) => (
                            <div
                                key={status}
                                className="statistic-card"
                                style={{
                                    flex: '1 1 calc(25% - 20px)',
                                    padding: '24px',
                                    minWidth: '140px',
                                    minHeight: '150px',
                                }}
                            >
                                <img
                                    style={{marginBottom: '14px'}}
                                    width={48}
                                    height={48}
                                    src={Clock}
                                    alt="status icon"
                                />
                                <div
                                    style={{
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        color: '#333',
                                        marginBottom: '6px',
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    <Translate text={key}/>
                                </div>
                                <div style={{fontSize: '20px', fontWeight: 700, color: myDarkBlue}}>
                                    {currentStatusHistory[status] ? formatSecondsToHHMMSS(currentStatusHistory[status]) : '00:00:00'}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </React.Fragment>

        </React.Fragment>
    );
};

const mapDispatchToProps = (dispatch) => ({
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});

export default connect(null, mapDispatchToProps)(OperatorStatistics);


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/components/OperatorStatistics.jsx